import type { Location } from 'history';
import { history } from '@atlassian/help-center-common-util/history';

let canNavigateBack = false;

// Modern Help Center request create forms use the direct path, for example */portal/1/create/2
function isRequestCreateLocation(location: Location): boolean {
	return /^\/portal\/\d+\/create\/[^/]+\/?$/.test(location.pathname);
}

export const initializeRequestCreatePreviousLocationTracking = (): (() => void) => {
	let currentLocation = history.location;

	const unlisten = history.listen((nextLocation, action) => {
		canNavigateBack =
			action === 'PUSH' &&
			isRequestCreateLocation(nextLocation) &&
			!isRequestCreateLocation(currentLocation);
		currentLocation = nextLocation;
	});

	return () => {
		canNavigateBack = false;
		unlisten();
	};
};

export const canNavigateBackFromRequestCreate = (): boolean => canNavigateBack;
